import { HttpServices } from './http.services'
import { API_URL } from './config.services'

async function addTickers(user_id: string, ticker: string) {
  const data = {
    user_id,
    ticker,
  }
  return HttpServices.doPost(`${API_URL}/addTickers`, data)
}

async function deleteTickers(user_id: string, ticker: string) {
  const data = {
    user_id,
    ticker,
  }
  return HttpServices.doPost(`${API_URL}/deleteTickers`, data)
}

async function getBondInvestors(
  user_id: string,
  ticker: string,
  start_date: string,
  end_date: string,
) {
  const data = {
    user_id,
    ticker,
    start_date,
    end_date,
  }
  return HttpServices.doGet(`${API_URL}/getBondInvestors`, data)
}

async function getScanCharts(
  user_id: string,
  ticker: string,
  chart_id: number,
) {
  const data = {
    user_id,
    ticker,
    chart_id,
  }
  return HttpServices.doGet(`${API_URL}/getScanCharts`, data)
}

async function getHighConviction(
  user_id: string,
  ticker: string,
  start_date: string,
  end_date: string,
) {
  const data = {
    user_id,
    ticker,
    start_date,
    end_date,
  }
  return HttpServices.doGet(`${API_URL}/getHighConviction`, data)
}

async function getEstimates(
  user_id: string,
  ticker: string,
  start_date: string,
  end_date: string,
) {
  const data = {
    user_id,
    ticker,
    start_date,
    end_date,
  }
  return HttpServices.doGet(`${API_URL}/getEstimates`, data)
}

async function getTickersOnlyInPortfolio(user_id: string) {
  const data = {
    user_id,
  }
  return HttpServices.doGet(`${API_URL}/getTickerData`, data)
}

async function getAllTickersInUniverse(user_id: string) {
  const data = {
    user_id,
  }
  return HttpServices.doGet(`${API_URL}/getTickers`, data)
}

async function getEvents(tickerId: string, userId: string) {
  const data = {
    user_id: userId,
    type: 'last',
    source: 'chartiq',
    param: tickerId,
    country: '',
  }
  return HttpServices.doGet(`${API_URL}/getData`, data)
}

async function getPrices(
  ticker: string,
  start_date: string,
  end_date: string,
  user_id: string,
) {
  const data = {
    ticker,
    start_date,
    end_date,
    user_id,
  }
  return HttpServices.doGet(`${API_URL}/getPrices`, data)
}

async function getPricesRisk(
  ticker: string,
  start_date: string,
  end_date: string,
  user_id: string,
) {
  const data = {
    ticker,
    start_date,
    end_date,
    user_id,
  }
  return HttpServices.doGet(`${API_URL}/getPricesRisk`, data)
}

async function getPortfolioUsers(client_id: string) {
  const data = {
    client_id,
  }
  return HttpServices.doGet(`${API_URL}/getPortfolioUsers`, data)
}

async function getCreditSeries(
  user_id: string,
  ticker: string,
  start_date: string,
  end_date: string,
) {
  const data = {
    user_id,
    ticker,
    start_date,
    end_date,
  }
  return HttpServices.doGet(`${API_URL}/getCreditSeries`, data)
}

async function getNotes(ticker: string, user_id: string) {
  const data = {
    ticker,
    user_id,
  }
  return HttpServices.doGet(`${API_URL}/getNotes`, data)
}

async function getWhatIf(ticker: string, user_id: string) {
  const data = {
    ticker,
    user_id,
  }
  return HttpServices.doGet(`${API_URL}/getWhatIf`, data)
}

async function postWhatIfCalculate(data: any) {
  return HttpServices.doPost(`${API_URL}/getScenarioOutputs`, data)
}

export const tickersService = {
  addTickers,
  deleteTickers,
  getBondInvestors,
  getScanCharts,
  getCreditSeries,
  getHighConviction,
  getEstimates,
  getTickersOnlyInPortfolio,
  getAllTickersInUniverse,
  getEvents,
  getPrices,
  getPricesRisk,
  getPortfolioUsers,
  getNotes,
  getWhatIf,
  postWhatIfCalculate,
}
